var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar',{on:{"logout":_vm.handleLogout}}),_c('dashboard-core-drawer'),_c('dashboard-core-view',{ref:"coreView"}),_c('dashboard-core-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }